import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  NgZone,
} from "@angular/core";
import { BentoAlertItemOptions } from "@bento/bento-ng";
import { ActivatedRoute,Router } from "@angular/router";
import {
  EventsAdmin,
  EventStatus,
} from "src/app/core/models/events-admin/events-admin";
import * as wjcCore from "@grapecity/wijmo";
import * as wjcGrid from "@grapecity/wijmo.grid";
import * as wjcGridFilter from "@grapecity/wijmo.grid.filter";
import { DocumentService } from "src/app/modules/gfr-document-search/document-explorer/document-view/services/document-view.service";
import { HttpClient } from "@angular/common/http";
import { EventsAdminService } from "../../services/events-admin.service";
import { DatePipe } from "@angular/common";
import { PopmodalService } from "src/app/core/services/popupmodel.service";
import {
  BentoModalConfirmationCloseReason,
  BentoModalConfirmationService,
  BentoToastService,
} from "@bento/bento-ng";
import { combineLatest, Subscription } from 'rxjs';


@Component({
  selector: "app-show-all-events",
  templateUrl: "./show-all-events.component.html",
  styleUrls: ["./show-all-events.component.scss"],
  providers: [DocumentService],
})
export class ShowAllEventsComponent implements OnInit {
  isListGrid: boolean = false;
  @ViewChild("flexGrid", {static: true}) flexGrid: wjcGrid.FlexGrid;
  @ViewChild("filter", {static: true}) gridFilter: wjcGridFilter.FlexGridFilter;
  data: wjcCore.CollectionView;
  // @ViewChild("filter", {static: true}) filter: ElementRef;
  filterValue: string;
  @ViewChild("deleteModal") deleteModal: ElementRef;
  notifcationRulesMessage: BentoAlertItemOptions[] = [];
  channels: any[] = [];
  products: any[] = [];
  pageInfo: any = {
    infoText: "_START_ to _END_ of _MAX_ Users",
    infoPageText: "_PAGE_ of _PAGES_",
    goText: "Go",
    pageSize: 10,
  };
  totalItemCount: number;
  public filteredColumns = [];
  isMainBusyLoaderBusy = false;

  columnDefinitions: any[] = [
    {
      binding: "actions",
      header: "Actions",
      filterType: 0,
      minWidth: 130,
      width: 130,
      allowSorting: false,
      allowDragging: false,
      isReadOnly: true,
    },
    {
      binding: "eventName",
      header: "Event Name",
      filterType: 3,
      visible: true,
      width: "*"
    },
    {
      binding: "creationDate",
      header: "CreationDate",
      filterType: 0,
      visible: true,
      width: "*",
    },
    {
      binding: "description",
      header: "Description",
      filterType: 0,
      visible: true,
      width: "*",
    },
    {
      binding: "associatedProduct",
      header: "Associated Product",
      filterType: 0,
      visible: true,
      width: "*",
    },
    {
      binding: "associatedChannel",
      header: "Associated Channel",
      filterType: 0,
      visible: true,
      width: "*",
    },
    {
      binding: "url",
      header: "Callback URL",
      filterType: 0,
      visible: true,
      width: "*",
    },
    {
      binding: "createdBy",
      header: "Created By",
      filterType: 0,
      visible: true,
      width: "*",
    },
    {
      binding: "endpoint_state",
      header: "Status",
      filterType: 0,
      visible: true,
      width: "*",
    },
  ];
  eventsData: any;
  flexGridData: EventsAdmin[] = [];
  columnDefinitionsByBinding: any = this.columnDefinitions.reduce(
    (result, item) => {
      result[item.binding] = item;
      return result;
    },
    {}
  );

  actions: any = {
    editRow: (item: EventsAdmin) => {
      this.navigateToRegistrationPage(item);
    },
    deleteRow: (item: EventsAdmin) => {
      var eventId = item.id;
      this.onDeleteButton(eventId);
    },
  };

  /**
   * Toolbar configruation data
   */
  toolbarConfig: any = {
    filterButtonHidden: false,
    filtersHidden: true,
    groupButtonHidden: false,
    groupPanelHidden: false,
    toggleFilter: this.toggleFilter.bind(this),
    toggleGroupPanel: () => {
      this.toolbarConfig.groupPanelHidden =
        !this.toolbarConfig.groupPanelHidden;
    },
  };

  toolbarData: any[] = [
    {
      label: "Add Event Registration",
      icon: "bento-icon-add",
      action: () => {
        this.ngZone.run(() => {
          this.eventsAdminService.updateEventDetailsGFR(this.flexGridData);
          this.router.navigate(["eventsAdmin/registration-page"]); // Redirect to registration-page
        });
      },
    },
  ];
  subscription: Subscription;

  constructor(
    private eventsAdminService: EventsAdminService,
    private router: Router,
    private datePipe: DatePipe,
    private ngZone: NgZone,
    private modalService: BentoModalConfirmationService,
    private toastService: BentoToastService
  ) {}

  ngOnInit(): void {
    this.initializeComponent();
  }

  initializeComponent(): void {   
    this.toggleFilter();
    this.setJwtToken().then(() => {
      this.loadInitialData();
    }).catch(error => {
      console.error('Error setting JWT token', error);
    });
  }

  setJwtToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.eventsAdminService.getJwtToken().subscribe({
        next: (resdata) => {
          localStorage.setItem("thjwttoken", resdata["token"]);
          resolve();
        },
        error: (error) => {
          console.error("Error fetching JWT token", error);
          reject(error);
        },
      });
    });
  }

  loadInitialData(): void {
  this.isMainBusyLoaderBusy = true;    
  this.subscription = combineLatest([
    this.getEventsDetails(),
    this.eventsAdminService.fetchChannels(),
    this.eventsAdminService.fetchProducts(),
    this.eventsAdminService.fetchEvents()
  ]).subscribe({
    next: ([eventsData, channels, products, events]) => {
      this.eventsData = eventsData;
      this.channels = channels;
      this.products = products;

      const productMap = this.products.reduce((map, product) => {
        map[product.id] = product.name;
        return map;
      }, {});

      const channelMap = this.channels.reduce((map, channel) => {
        map[channel.id] = channel.name;
        return map;
      }, {});

      let realmId = this.eventsAdminService.getRealmId();
      let data = events.map((event) => {
        return {
          id: event.id,
          channel_id: event.channel_id,
          name: event.name,
          product: event.product,
          creationDate: null,
          eventName: event.name,
          description: null,
          associatedProduct: productMap[realmId] || "Unknown",
          associatedChannel: channelMap[event.channel_id] || "Unknown",
          url: event.url,
          createdBy: null,
          endpoint_state: EventStatus[event.endpoint_state],
          distribution_attributes: event.distribution_attributes,
        } as EventsAdmin;
      });
      this.flexGridData.push(data);
    // mapping created by to data
    data = this.combineData(data, this.eventsData);
      this.data = new wjcCore.CollectionView(data, {
        pageSize: this.pageInfo.pageSize,
      });
    
      this.totalItemCount = this.data.totalItemCount;
      this.filteredColumns = [
        "eventName",
        "description",
        "associatedProduct",
        "associatedChannel",
        "url",
        "createdBy",
        "creationDate",
        "endpoint_state",
      ];
      this.isMainBusyLoaderBusy = false;
    },
    error: (error) => {     
      console.error('Error loading initial data', error);
      this.isMainBusyLoaderBusy = false;
    }    
  });
  }
 
  combineData(data1: any[], data2: any[]): any[] {
    if (!data2 || data2.length === 0) {
      return data1;
  }
 
    const data2Map = new Map(data2.map(item => [item.id, item]));
    
    const combinedData = data1.map(item1 => {
      const item2 = data2Map.get(item1.id);
      return {
        ...item1,
        createdBy: item2?.created_by ?? null,
        description: item2?.description ?? null,
        creationDate: item2 ? this.datePipe.transform(item2.created_date, 'MM/dd/yyyy hh:mm:ss a') : null,
        schemaId: item2?.schema_id ?? null
    };
    });
    return combinedData;
  }
  toggleFilter() {
    this.toolbarConfig.filtersHidden = !this.toolbarConfig.filtersHidden;
    if (this.gridFilter) {
      if (this.toolbarConfig.filtersHidden) {
        this.gridFilter.clear();
      }
      for (let i = 0, il = this.columnDefinitions.length; i < il; i++) {
        const col = this.gridFilter.grid?.columns.getColumn(
          this.columnDefinitions[i].binding
        );
        const cf: any = col ? this.gridFilter.getColumnFilter(col, true) : {};
        cf.filterType = this.toolbarConfig.filtersHidden
          ? 0
          : this.columnDefinitions[i].filterType;
      }
      this.gridFilter.grid?.refresh();
    }
  }

  updateFlexGridRowHeight(grid, height, headHeight) {
    height = height || 36;
    grid.rows.defaultSize = height;
    const headerHeight = 36;
    for (let i = 0, total = grid.columnHeaders.rows.length; i < total; i++) {
      grid.columnHeaders.rows[i].height =
        headHeight && headHeight[i] ? headHeight[i] : headerHeight;
    }
  }

  closeResult;

  onDeleteButton(eventId: string) {
    this.modalService
      .open("Are you sure you want to delete this Event registration?", {
        iconName: "bento-icon-warning-filled",
        iconColorType: "danger",
        confirmButtonText: "Delete",
      })
      .result.then(
        (result: BentoModalConfirmationCloseReason) => {
          this.closeResult = `Closed with: ${result}`;

          if (result === BentoModalConfirmationCloseReason.Confirm) {
            this.isMainBusyLoaderBusy = true;
            this.eventsAdminService.removeEvent(eventId).subscribe({
              next: (response) => {
                const msg = "Event registration deleted successfully!";
                this.toastService.open(msg, { type: "success", duration: 2500 });
                this.DeleteGFREventDetails(eventId);
              },
              error: (error) => {
                let errorMsg = "Error deleting event!";
                this.toastService.open(errorMsg, {
                  type: "danger",
                  duration: 2500,
                });
              },
            });
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${reason}`;
        }
      );
  }

  // filter by eventName
  filterEvent(e: any) {
    let filter = (<HTMLInputElement>e.target).value.toLowerCase();
    this.data.filter = (item: any) => {
      return (
        filter.length == 0 || item.eventName.toLowerCase().indexOf(filter) > -1
      );
    };
  }

  /**
   * Handler for FlexGrid's Initialized method
   */
  gridInitialized() {
    // select cell under 'ID' column in first row
    if (this.flexGrid) {
      this.flexGrid.select(new wjcGrid.CellRange(0, 1, 0, 1), true);
    }
  }

  /**
   * Pagination Size Changed Event Handler
   */
  onPageSizeChanged(size) {
    this.data.pageSize = size;
  }

  /**
   * Pagination Page Changed Event Handler
   */
  onPageChanged(page) {
    this.data.moveToPage(page - 1);
  }

 

  navigateToRegistrationPage(item: EventsAdmin): void {
    this.ngZone.run(() => {
      // Ensure navigation is within Angular zone
      this.router.navigate(["eventsAdmin/registration-page"], {
        state: { event: item},  queryParams: { id: item.id, description: item.description, schemaId: item.schemaId, channelId: item.channel_id  } 
      });
    });
  }
  // Getting transit-hub data using FFApis
  // get createdby events using ffapi
  getEventsDetails(){
    return this.eventsAdminService.getEventDetailsGFR();
  }

  private DeleteGFREventDetails(eventId){
    this.eventsAdminService.removeEventGFR(eventId).subscribe({
      next: (response) => {
        this.loadInitialData();
        this.isMainBusyLoaderBusy = false;
      },
      error: (error) => {
      },
    });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}